<template>
  <div class="home">
    <!-- <el-alert title="提示：为了您有更好的学习体验，推荐使用谷歌浏览器！" type="warning" center show-icon></el-alert> -->
    <div class="content">
      <!-- <div class="lang">
        <p>住房和城乡建设领域施工现场专业人员培训平台</p>
      </div>-->
      <div class="title">
        <p>住房和城乡建设领域</p>
        <p>施工现场专业人员考前教育平台</p>
      </div>
      <div class="login bs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="学员" name="first">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" style="padding:0 50px">
              <el-form-item prop="user">
                <el-input
                  prefix-icon="el-icon-user-solid"
                  v-model="ruleForm.user"
                  placeholder="用户名"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="pass">
                <el-input
                  type="password"
                  v-model="ruleForm.pass"
                  autocomplete="new-password"
                  prefix-icon="el-icon-lock"
                  placeholder="密码"
                  @keyup.enter.native="student('ruleForm')"
                  clearable
                ></el-input>
              </el-form-item>
              <el-row>
                <!-- <a href="http://bdy.eceyun.net/user/">
                <el-button type="primary">登录</el-button>
                </a>-->
                <el-button style="width:100%" type="primary" @click="student('ruleForm')">登录</el-button>
              </el-row>
              <el-row>
                <el-button
                  style="width:100%;margin-top:10px"
                  type="primary"
                  @click="chooseDialog = true"
                >个人注册</el-button>
              </el-row>
              <el-row class="enter">
                <span class="cur" @click="forgetDialog = true">忘记密码?</span>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="培训机构" name="second">
            <el-form
              ref="companyForm"
              :model="companyForm"
              :rules="companyRule"
              style="padding:0 50px"
            >
              <el-form-item prop="name">
                <el-input
                  v-model="companyForm.name"
                  prefix-icon="el-icon-user-solid"
                  placeholder="企业用户名"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="pass">
                <el-input
                  type="password"
                  v-model="companyForm.pass"
                  autocomplete="new-password"
                  prefix-icon="el-icon-lock"
                  placeholder="密码"
                  @keyup.enter.native="organLogin('companyForm')"
                  clearable
                ></el-input>
              </el-form-item>
              <el-row>
                <!-- <a href="http://bdy.eceyun.net/school/" target="_blank"> -->
                <el-button style="width:100%" type="primary" @click="organLogin('companyForm')">登录</el-button>
                <!-- </a> -->
                <!-- <div class="enter">
                <span class="cur" @click="firmDialog = true">企业注册</span>
                </div>-->
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="管理部门" name="third">
            <el-form
              ref="manageForm"
              :model="manageForm"
              :rules="manageRule"
              style="padding:0 50px"
            >
              <el-form-item>
                <el-input
                  v-model="manageForm.name"
                  prefix-icon="el-icon-user-solid"
                  placeholder="管理账号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  type="password"
                  v-model="manageForm.pass"
                  autocomplete="new-password"
                  prefix-icon="el-icon-lock"
                  placeholder="密码"
                  @keyup.enter.native="chartLogin('manageForm')"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item class="bot">
                <el-button style="width:100%" type="primary" @click="chartLogin('manageForm')">登录</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <p class="tip">提示：为了您有更好的学习体验，推荐使用谷歌浏览器！</p>
    </div>
  </div>
</template>

<script>
import http from "../api/login";
import { IsLocal } from "../api/baseUrl";

export default {
  name: "login",
  data() {
    return {
      activeName: "second",
      ruleForm: {
        user: "",
        pass: ""
      },
      chooseDialog: false,
      chooseForm: {
        name: ""
      },
      loginDialog: false,
      loginForm: {
        name: "",
        sex: "1",
        card: "",
        company: "",
        phone: "",
        code: "",
        special: ""
      },
      forgetDialog: false,
      forgetForm: {
        name: "",
        card: "",
        newpsd: "",
        surepsd: "",
        phone: "",
        code: ""
      },
      companyForm: {
        name: "",
        pass: ""
      },
      manageForm: {
        name: "",
        pass: ""
      },
      rules: {
        user: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        pass: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      companyRule: {
        name: [
          { required: true, message: "请输入企业用户名", trigger: "blur" }
        ],
        pass: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      manageRule: {
        user: [{ message: "请输入用户名", trigger: "blur" }],
        pass: [{ message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  components: {},
  created() {
    var type = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
      ? "mobile"
      : "PC";
    if (type == "mobile") {
      this.$router.push({
        path: "/null"
      });
      this.fullscreenLoadingfullscreenLoading = false;
      return false;
    }
  },
  mounted() {
    // this.getEnterprise();
  },
  methods: {
    student(formName) {},
    // 培训机构登录
    organLogin(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.getLogin(this.companyForm.name, this.companyForm.pass);
        } else {
          return false;
        }
      });
    },
    getLogin(name, pass) {
      http
        .login({
          empUname: name,
          empUpass: pass
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            var data = data.data.data;
            // var tokenId = data.tokenId;
            // var entpId = data.entpId;
            sessionStorage.setItem("token", data.tokenId);
            sessionStorage.setItem("entpId", data.entpId);
            sessionStorage.setItem("username", data.entpName);
            sessionStorage.setItem("auditConfFlag", data.auditConfFlag);
            sessionStorage.setItem(
              "updateStudyTimeConfFlag",
              data.updateStudyTimeConfFlag
            );
            sessionStorage.setItem("singlePhoto", data.singlePhoto);
            sessionStorage.setItem("batchPhoto", data.batchPhoto);
            // window.open(`http://bdy.eceyun.net/school?entpId=${entpId}`);
            // window.open(`http://localhost:8081/#/?entpId=${entpId}`);
            this.$router.push({
              path: "/home"
            });
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    handleClick(tab, event) {
      if (tab.index == "0") {
        // window.location.replace("/");
        if (IsLocal) {
          window.location.replace("/");
        } else {
          window.location.replace("https://bdy.kq.hbzclm.com");
        }
        // window.location.replace("http://localhost:8080/#/login");
        // window.location.replace("https://bdy.eceyun.net/#/");
      } else if (tab.index == "1") {
        // window.location.replace("/school/#/login");
        if (IsLocal) {
          window.location.replace("/school/#/login");
        } else {
          window.location.replace("https://school.kq.hbzclm.com");
        }
        // window.location.replace("http://localhost:8081/#/login");
        // window.location.replace("https://bdy.eceyun.net/school/#/login");
      } else if (tab.index == "2") {
        // window.location.replace("/manage/#/login");
        if (IsLocal) {
          window.location.replace("/manage/#/login");
        } else {
          window.location.replace("https://manager.kq.hbzclm.com");
        }
        // window.location.replace("http://localhost:8082/#/login");
        // window.location.replace("https://bdy.eceyun.net/manage/#/login");
      }
    },
    // 管理后台登录
    chartLogin() {}
  }
};
</script>
<style lang="less" scoped>
/deep/.el-tabs__header {
  margin-bottom: 30px;
}
/deep/.el-tabs__nav {
  margin-left: 60px;
  // margin-left: 80px;
}
/deep/#tab-first {
  padding-left: 20px;
}

.home {
  height: 100%;
  background: url("../assets/images/bg.jpg") no-repeat center;
  background-size: cover;
  position: relative;
  .content {
    width: 450px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 13%;
    transform: translateX(-50%);
  }
  .title {
    color: rgb(49, 48, 48);
    text-align: center;
    margin-bottom: 20px;

    p {
      font-size: 30px;
      font-weight: 600;
      line-height: 50px;
    }

    // line-height   : 100px;
    // text-shadow: 0 0 5px #000;
    // text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
    // text-shadow: black 0.1em 0.1em 0.2em;
    // text-shadow: 0 0 0.2em #666, 0 0 0.2em #666, 0 0 0.2em #666;
  }
  .login {
    background: #fff;
    border-radius: 6px;
    min-height: 330px;
    padding: 20px;
  }
  .tip {
    line-height: 50px;
    color: red;
    font-size: 18px;
    font-weight: 600;
  }
  .bot {
    /deep/.el-form-item__content {
      text-align: center;
      margin-left: 0 !important;
    }
    /deep/.el-button--primary {
      width: 60%;
    }
  }
  .enter {
    text-align: center;
    margin-top: 10px;
    span {
      color: #409eff;
      text-decoration: underline;
      transition: 0.3s;
      &:hover {
        color: #66b1ff;
      }
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1600px) {
    .top {
      font-size: 28px;
      top: 8%;
    }
  }
}

.info {
  // padding: 10px 30px;
  .line {
    .sex {
      /deep/.el-radio {
        width: 20%;
        float: left;
      }
    }
    /deep/.el-form-item {
      width: 44%;
      // float: left;
      display: inline-block;
      margin-right: 50px;
    }
    /deep/.el-form-item__label {
      font-size: 16px;
    }
    /deep/.el-select {
      width: 100%;
    }
  }
  .create {
    /deep/.el-form-item__content {
      margin-left: 0 !important;
      text-align: center;
    }
  }
  .choose {
    /deep/.el-input {
      width: 40%;
      margin-right: 10px;
    }
  }
}
</style>
